import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    Settings2, Building2, DollarSign, Receipt, FileText,
    Mail, GitBranch, ChevronRight
} from 'lucide-react';
import { PageHeader } from '../../components/layout';
import { Card, CardBody } from '../../components/common';
import './Settings.css';

const settingsNav = [
    { key: 'company', label: 'Company Profile', icon: Building2, path: '/settings/company' },
    { key: 'currency', label: 'Currency', icon: DollarSign, path: '/settings/currency' },
    { key: 'tax', label: 'Tax Configuration', icon: Receipt, path: '/settings/tax' },
    { key: 'payment-terms', label: 'Payment Terms', icon: FileText, path: '/settings/payment-terms' },
    { key: 'numbering', label: 'Document Numbering', icon: FileText, path: '/settings/numbering' },
    { key: 'email-templates', label: 'Email Templates', icon: Mail, path: '/settings/email-templates' },
    { key: 'approval-rules', label: 'Approval Rules', icon: GitBranch, path: '/settings/approval-rules' }
];

export default function SettingsLayout({ children }) {
    const location = useLocation();

    return (
        <div className="settings-layout">
            <PageHeader
                title="Settings"
                subtitle="System configuration"
                breadcrumbs={[{ label: 'Settings', path: '/settings' }]}
            />

            <div className="settings-content">
                <Card className="settings-sidebar">
                    <CardBody>
                        <nav className="settings-nav">
                            {settingsNav.map((item) => {
                                const isActive = location.pathname === item.path;
                                return (
                                    <Link
                                        key={item.key}
                                        to={item.path}
                                        className={`settings-nav-item ${isActive ? 'active' : ''}`}
                                    >
                                        <item.icon size={18} />
                                        <span>{item.label}</span>
                                        <ChevronRight size={16} className="nav-arrow" />
                                    </Link>
                                );
                            })}
                        </nav>
                    </CardBody>
                </Card>

                <div className="settings-main">
                    {children || <SettingsHome />}
                </div>
            </div>
        </div>
    );
}

function SettingsHome() {
    return (
        <Card>
            <CardBody>
                <div className="settings-home">
                    <Settings2 size={48} />
                    <h2>System Settings</h2>
                    <p>Select a category from the sidebar to configure system settings.</p>
                </div>
            </CardBody>
        </Card>
    );
}
